<template>
    <header class="header">

                       <div id="headerButton" v-if="showSandwichMenu" class="navigation-trigger d-inline" :class="{'toggled': sliderStatus === 'open'}" data-ma-action="aside-open" @click="toggleSlider()">
               <div class="navigation-trigger__inner">
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
               </div>
            </div>
        <div class="header__logo">
            <h1 class="d-inline font-weight-light">
                <a href="#">{{ title }}</a>
            </h1>
        </div>
        <ul class="top-nav">
            <li><avatar :record="userId"></avatar></li>
            <li><span>{{ fullname }}</span></li>
            <li><a @click="logout"><i class="zmdi zmdi-power"></i></a></li>
        </ul>
    </header>
</template>

<script>
    import IniSearchbox from '@/components/SearchBox'
    import Avatar from "../components/Avatar";

    export default {
        props: {
            title: String,
            fullname: String,
            searchBoxPlaceholder: String,
            userId: String,
            showSandwichMenu: {default: true},
            slider: {default: 'menuSidebar'},
        },
        data() {
            return {
                sliderStatus: 'open'
            }
        },
        beforeMount() {
            if(this.isMobileScreen()){
                this.sliderStatus = 'close'
            }
        },
        components: {
            IniSearchbox,
            Avatar
        },
        mounted() {
            this.$eventBus.$on('toggleSlider', (data) => {
                if(data.slider !== this.slider){
                    return
                }

                this.sliderStatus = data.status
            })
        },
        methods: {
            logout : function() {
                Api.logout();
            },
            toggleSlider() {
                this.sliderStatus = this.sliderStatus === 'open' ? 'close' : 'open'
                this.$eventBus.$emit('toggleSlider', {slider: this.slider, status: this.sliderStatus})
            }
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/layout/_header.scss";</style>